import { Rating, Box, Typography } from "@mui/material";

interface StarRatingProps {
    value: number;       // rating value (e.g., 3.5)
    numRatings?: number; // number of reviews
}

export const StarRating = ({ value, numRatings = 0 }: StarRatingProps) => {
    const hasReviews = value > 0 && numRatings > 0;

    return (
        <Box display="flex" alignItems="center" gap={0.5}>
            <Rating
                name="single-star-rating"
                value={1} // always show 1 star filled
                max={1}
                readOnly
                size="small"
                sx={{
                    "& .MuiRating-iconFilled": {
                        color: hasReviews ? "#162C1F" : "#ccc", // green if reviews, grey if none
                    },
                }}
            />
            <Typography variant="body2" color="text.secondary">
                ({numRatings})
            </Typography>
        </Box>
    );
};
